import React from "react";
import { connect } from "react-redux";

import ProductHeader from "../../ProductDetails/ProductHeader";
import ProductName from "./ProductName";
import ProductQuantity from "./ProductQuantity";
import Quantity from "../Quantity";
import ProductDescription from "./ProductDescription";
import ActionButton from "../../ActionButton";
import instance from "../../../store/actions/instance";
import moment from "moment";
import { withRouter } from "react-router-dom";
import ProductCarousel from "./ProductCarousel";

import {
  setProduct,
  cartToQuantity,
  setB2BNoticeBannerVisibility,
  fetchCategories,
  checkMOV,
  checkWalletBalance,
  setPhoneNumber,
  setMethod,
  setUsedComponents,
} from "../../../store/actions/b2b";
import { getProductInventory } from "../../../store/reducers/store";
class ProductDetails extends React.Component {
  quantity = 1;

  constructor(props) {
    super(props);
    this.state = {
      quantity: 1,
    };
  }

  async fetchDistributorInfo() {
    const res = await instance.post(`/get_distributor_info/`, {
      slug: this.props.match.params.slug,
    });
    if (res.data == -1) return this.props.history.replace("/");
    let leadTime = res.data.lead_time;
    let todayName = moment().format("dddd").toLowerCase();

    if (res.data[`deliver_on_${todayName}`]) {
      if (moment().format("HH:mm") > res.data[`${todayName}_cutoff`]) {
        leadTime += 1;
      }
    } else {
      leadTime += 1;
    }
    let initialDate = moment().locale("en").add(leadTime, "days");
    while (true) {
      if (
        (initialDate.isoWeekday() == 7 && !res.data.deliver_on_sunday) ||
        (initialDate.isoWeekday() == 1 && !res.data.deliver_on_monday) ||
        (initialDate.isoWeekday() == 2 && !res.data.deliver_on_tuesday) ||
        (initialDate.isoWeekday() == 3 && !res.data.deliver_on_wednesday) ||
        (initialDate.isoWeekday() == 4 && !res.data.deliver_on_thursday) ||
        (initialDate.isoWeekday() == 5 && !res.data.deliver_on_friday) ||
        (initialDate.isoWeekday() == 6 && !res.data.deliver_on_saturday)
      ) {
        initialDate = initialDate.add(1, "days");
      } else break;
    }
    if (!res.data.enable_on_credit_payments) this.props.hideB2BUserButton();

    let categories = {};
    res.data.products.forEach((product) => {
      const categoryId = product.product.category;
      if (!categories[categoryId]) {
        categories[categoryId] = {
          category_name: product.product.category_name,
          category_ar_name: product.product.category_ar_name,
          slug: product.product.category_slug,
          id: categoryId,
          products: [],
        };
      }
      categories[categoryId].products.push(product);
    });

    this.props.fetchCategories(Object.values(categories));
    this.props.setDistributorNoticeBannerOverride(res.data.override_banner);
    this.props.setDistributorNoticeBanner(res.data.enable_banner);
  }

  SetQuantity = (quantity) => {
    this.quantity = quantity;
    this.SetActionButtonSubTotal(this.calculateSubTotal());
  };

  calculateSubTotal = () => {
    let calculated_quantity = this.quantity;
    if (calculated_quantity < 0) calculated_quantity = 0;

    return this.getTotalPrice(
      this.props.product.product.price,
      calculated_quantity,
      true,
      true
    );
  };

  componentDidMount = async () => {
    if (!(this.props.categories || []).length) {
      await this.fetchDistributorInfo();
      let category = this.props.categories.find(
        (category) => category.slug === this.props.match.params.CategorySlug
      );

      if (category) {
        let product = category.products.find(
          (item) => item.product.slug === this.props.match.params.ProductSlug
        );

        if (product) {
          this.props.setProduct(product);
        }
      }
    }
    this.props.setB2BNoticeBannerVisibility(true);
  };

  SetActionButtonSubTotal = (func) => {
    if (typeof func === "function") {
      this.SetActionButtonSubTotal = func;
      this.SetActionButtonSubTotal(this.calculateSubTotal());
    }
  };

  getActionButtonText = () => {
    let customTexts = this.props.settings.custom_texts;
    return this.props.language == "english"
      ? customTexts.add_to_cart
      : customTexts.add_to_cart_ar;
  };

  getTotalPrice = (sum, quantity) => {
    if (quantity <= 0) return 0;
    sum = sum * quantity;
    return sum;
  };

  render() {
    const {
      language,
      categories,
      settings,
      product,
      usedComponents,
      minimumOrderQuantity,
    } = this.props;
    if (!product) return <></>;
    let customTexts = this.props.settings.custom_texts;

    if (!customTexts) {
      customTexts = {
        add_to_cart: "Add to Cart",
        add_to_cart_ar: "اضف للسلة",
      };
    }

    const preventAddButton = this.state.loading;
    const minimumQuantity = product.minimum_order_quantity || 1;
    const isOutOfStock =
      getProductInventory(product?.product, usedComponents, true) <
      minimumQuantity;

    return (
      <div
        className="w-100 h-100 mb-5"
        style={{ minHeight: window.innerHeight }}
        onClick={(e) => {
          if (preventAddButton) e.stopPropagation();
        }}
      >
        <ProductHeader
          onBack={() => {
            // this.props.history.goBack();
            this.props.history.replace(
              "/" + this.props.match.params.slug + "/"
            );
          }}
        />

        <ProductCarousel />
        <ProductName
          SetQuantity={(quantity) => this.SetQuantity(quantity)}
          productQuantity={this.quantity}
        />

        <ProductDescription />

        <div className="free-space-50"></div>
        <ActionButton
          SetActionButtonSubTotal={(func) => this.SetActionButtonSubTotal(func)}
          fromProduct={false}
          fromB2BProduct={true}
          disabled={isOutOfStock}
          subTotal={true}
          subTotalValue={this.calculateSubTotal()}
          action={this.getActionButtonText()}
          isDetailPage
          enableBuyNow={true}
          onClick={() => {
            const currentQuantity =
              this.props.cart[this.props.product.product.id] || 0;
            const totalQuantity = this.quantity + currentQuantity;

            this.props.cartToQuantity(
              this.props.product.product.id,
              this.quantity
            );

            this.props.setUsedComponents({
              product: this.props.product.product,
              quantityDelta: this.quantity,
            });

            this.props.checkMOV(this.props.cart, this.props.match.params.slug);
            this.props.checkWalletBalance(
              this.props.match.params.slug,
              this.props.phoneNumber,
              this.props.cart
            );
            this.props.history.goBack();
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    store: state.store.store,
    cart: state.b2b.cartToQuantity,
    settings: state.store.store.settings,
    product: state.b2b.selectedProduct,
    categories: state.b2b.categories,
    phoneNumber: state.b2b.phoneNumber,
    usedComponents: state.b2b.usedComponents,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setProduct: (prd) => dispatch(setProduct(prd)),
    setB2B: () => dispatch({ type: "SET_B2B" }),
    hideB2BUserButton: () => dispatch({ type: "HIDE_B2B_USER_BUTTON" }),
    setB2BProfileOpen: (val) =>
      dispatch({ type: "SET_B2B_PROFILE_OPEN", payload: val }),
    cartToQuantity: (id, value) => dispatch(cartToQuantity(id, value)),
    checkMOV: (cart, slug) => dispatch(checkMOV(cart, slug)),
    setMethod: (value) => dispatch(setMethod(value)),
    fetchCategories: (value) => dispatch(fetchCategories(value)),
    checkWalletBalance: (slug, phone, cart, method = null) =>
      dispatch(checkWalletBalance(slug, phone, cart, method)),
    setPhoneNumber: (value) => dispatch(setPhoneNumber(value)),
    emptyCart: () => dispatch({ type: "EMPTY_CART" }),
    setB2BNoticeBannerVisibility: (value) =>
      dispatch(setB2BNoticeBannerVisibility(value)),
    setDistributorNoticeBanner: (value) =>
      dispatch({
        type: "SET_DISTRIBUTOR_NOTICE_BANNER",
        payload: value,
      }),
    setDistributorNoticeBannerOverride: (value) =>
      dispatch({
        type: "SET_DISTRIBUTOR_NOTICE_BANNER_OVERRIDE",
        payload: value,
      }),
    setUsedComponents: (payload) => dispatch(setUsedComponents(payload)),
  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductDetails)
);
